import { render, staticRenderFns } from "./NodeTree.vue?vue&type=template&id=477884f0&scoped=true"
import script from "./NodeTree.vue?vue&type=script&lang=js"
export * from "./NodeTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477884f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477884f0')) {
      api.createRecord('477884f0', component.options)
    } else {
      api.reload('477884f0', component.options)
    }
    module.hot.accept("./NodeTree.vue?vue&type=template&id=477884f0&scoped=true", function () {
      api.rerender('477884f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NodeTree.vue"
export default component.exports